import { i18n as _i18n } from "@lingui/core";
import { useCallback, useEffect } from 'react';
import { CheveronRightIcon } from '@wkda/icons';
import { Button } from '@wkda/styleguide';
import { useCarleadDataLayer } from '../../hooks/useCarleadDataLayer';
import { useTrackCustomerBanner } from '@wkda/funnel-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BannerCancelledAppointment(props) {
  const dataLayer = useCarleadDataLayer();
  const {
    trackShownEvent,
    trackCTAClickEvent,
    getCJTrackingButtonNameByAttr
  } = useTrackCustomerBanner();
  useEffect(() => {
    dataLayer.pushCustomerBannerOpen('cancelled-banner');
    trackShownEvent('cancelled-banner');
  }, [dataLayer, trackShownEvent]);
  const handleCTAClick = useCallback(e => {
    const ctaName = getCJTrackingButtonNameByAttr(e.currentTarget);
    if (ctaName) {
      trackCTAClickEvent('cancelled-banner', ctaName);
    }
  }, [getCJTrackingButtonNameByAttr, trackCTAClickEvent]);
  return /*#__PURE__*/_jsxs("div", {
    className: "cancelled-appointment-rcb d-flex flex-column justify-content-center align-items-center",
    children: [/*#__PURE__*/_jsx("p", {
      className: "cancelled-appointment-rcb__text text-primary font-weight-bold m-0 text-center",
      dangerouslySetInnerHTML: {
        __html: _i18n._(
        /*i18n*/
        {
          id: 'carleadCreation.cancelledAppointmentBanner.title'
        })
      }
    }), /*#__PURE__*/_jsx(Button, {
      "data-cj-tracking-button-name": "cancelled-appointment-button",
      className: "cancelled-appointment-rcb__button",
      component: "a",
      variant: "secondary",
      size: "lg",
      href: props.bookingUrl,
      onClick: handleCTAClick,
      children: /*#__PURE__*/_jsxs("div", {
        className: "d-flex justify-content-center align-items-center",
        children: [_i18n._(
        /*i18n*/
        {
          id: 'carleadCreation.cancelledAppointmentBanner.button'
        }), /*#__PURE__*/_jsx(CheveronRightIcon, {
          className: "ml-2"
        })]
      })
    })]
  });
}